import React from "react";
import { createRoot } from "react-dom/client";
import AtlasBrowser from "./AtlasBrowser";
import CorrespondenceNetwork from "./CorrespondenceNetwork";
import { start as startHoverCards } from "./hoverCard";
import { start as startTrail } from "./trail";

function mountNode(element) {
  if (!element || element.dataset.mounted === "true") return;
  const payload = JSON.parse(element.dataset.correspondences);
  const atlas = JSON.parse(element.dataset.atlas);
  element.dataset.mounted = "true";
  createRoot(element).render(<CorrespondenceNetwork atlas={atlas} payload={payload} />);
}

function mountAtlas(element) {
  if (!element || element.dataset.mounted === "true") return;
  const atlas = JSON.parse(element.dataset.atlas);
  element.dataset.mounted = "true";
  createRoot(element).render(<AtlasBrowser atlas={atlas} />);
}

// Delegated from the document, so it serves the server-rendered tables as well
// as anything React draws.
startHoverCards();

function mountAll() {
  startTrail();
  document.querySelectorAll("#correspondence-network").forEach(mountNode);
  document.querySelectorAll("#correspondence-atlas").forEach(mountAtlas);
}

document.addEventListener("DOMContentLoaded", mountAll);
document.addEventListener("turbo:load", mountAll);
